<template lang="pug">
f7-button(fill, :disabled='disabled', @click='$emit("click", $event)')
  .button-box
    svg-icon(icon='sort')
    | {{ title }}
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    disabled: { type: Boolean, required: false },
  },
}
</script>

<style lang="scss" scoped>
.svg-icon {
  width: 24px;
  height: 24px;
  padding-top: 1px;
}
</style>
